import { Component, OnInit, Inject, ViewChild } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { NgForm } from '@angular/forms';
import { finalize } from 'rxjs/operators';
import { JobDialog } from '../../../../models/jobDialog';
import { ProjectService } from '../../../../shared/services/project.service';
import { NzNotificationService } from 'ng-zorro-antd/notification';


@Component({
    selector: 'app-job-delete',
    templateUrl: './job-delete.component.html',
    styleUrls: ['./job-delete.component.less'],
    standalone: false
})
export class JobDeleteComponent implements OnInit {
  @ViewChild(NgForm, { static: true }) form;
  loading = false;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: JobDialog,
    public dialogRef: MatDialogRef<JobDeleteComponent>,
    private notificationService: NzNotificationService,
    private projectService: ProjectService,
  ) { }

  ngOnInit() {
  }

  submitForm() {
    if (!this.form.valid || this.loading)
      return;

    this.loading = true;
    this.projectService
      .deleteJob(this.data.id)
      .pipe(finalize(() => (this.loading = false)))
      .subscribe({
        next: () => {
          this.dialogRef.close(this.data)
          this.notificationService.success("Deleted", "Job successfully deleted");
        },
        error: () => {
          this.notificationService.error("Error", "Job could not be deleted");
        },
      });
  }
}
